exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toggleContainer{display:inline-block;width:100%;margin:1em 0;text-align:center}.toggleContainer .active{color:#fff;background-color:#00a0f4}.toggleContainer .btn:focus{outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/district_org_list_page.scss
// module id = 825
// module chunks = 0